import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Button, FormControl, FormControlLabel, Stack, Switch, TextField, Typography, useTheme } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup"
import UnstyledLink from '../../components/common/UnstyledLink/UnstyledLink';
import { assetsApi, contractorsApi, usersApi } from '../../api-interface';
import { useContext, useState } from 'react';
import { TenantContext } from '../..';
import { useSnackbar } from 'notistack';


const ContractorAdd = () => {

    const { enqueueSnackbar } = useSnackbar();

    const currentTenant = useContext(TenantContext)
    const navigate = useNavigate()

    const schema = yup
        .object({
            name: yup.string().required(),
            notes: yup.string(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [apiError, setApiError] = useState<string>("")
    const theme = useTheme()

    const handleNewContractor = async (x) => {
        try {
            await contractorsApi(currentTenant).createContractorContractorsPost({
                "name": x.name,
                "notes": x.notes,
            }
            )
            enqueueSnackbar('Contractor added', { variant: "success" })
            navigate("/dashboard/" + currentTenant + "/contractors")
        } catch (e) {
            if (e?.response?.data?.detail) {
                setApiError(e.response.data.detail)
            } else {
                enqueueSnackbar("Error: " + e, { variant: "error" })
            }
        }
    }


    return (
        <Grid size={{xs:11}}>
            <Grid rowSpacing={2} container>
                <Grid size={{xs:12}}>
                    <Typography variant="h4" > Add new Contractor </Typography>
                </Grid>
                <Grid size={{xs:12, sm: 12, md: 12, lg:8, xl:4}}>
                    <form onSubmit={handleSubmit(handleNewContractor)}>
                        <FormControl fullWidth>
                            <Typography marginTop={3} variant='subtitle1'>Contractor Details</Typography>
                            <TextField
                                margin="normal"
                                label="Name"
                                placeholder="Name"
                                {...register('name')}
                                error={errors.name ? true : false}
                                helperText={errors.name?.message?.toString()}
                                type="text"
                                variant='outlined'
                                required
                            />
                            <TextField
                                margin="normal"
                                label="Notes"
                                placeholder="Notes"
                                {...register('notes')}
                                multiline
                                rows={2}
                                error={errors.notes ? true : false}
                                helperText={errors.notes?.message?.toString()}
                                type="text"
                                variant='outlined'
                            />
                        </FormControl>
                        <FormControl>
                            <Typography mt={2} color={theme.palette.error.main} display={apiError ? "block" : "none"}>
                                {apiError}
                            </Typography>
                            <Stack marginTop={5} spacing={2} direction="row">
                                <UnstyledLink to=".." relative="path"><Button variant="outlined" >Cancel</Button></UnstyledLink>
                                <Button variant="contained" type="submit">Save</Button>
                            </Stack>

                        </FormControl>

                    </form>

                </Grid>
            </Grid>
        </Grid>
    )
}

export default ContractorAdd